function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
export const BellTiltedIcon = /*#__PURE__*/forwardRef(({
  className,
  style,
  ariaLabel,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  ref: ref,
  className: className,
  "aria-label": ariaLabel || "bell, bell titled, tilted, notifications",
  style: style,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.2381 3.74208C14.5555 2.08379 11.8308 2.08707 10.1482 3.74536L6.33703 7.50155L3.70775 7.50049C3.2622 7.50031 3.03894 8.03899 3.35399 8.35404L11.6464 16.6464C11.9614 16.9614 12.5 16.7383 12.5 16.2929V13.4313L16.238 9.74721C17.9206 8.08893 17.9206 5.40037 16.2381 3.74208Z",
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 14.3137C8.08494 15.2288 6.60135 15.2288 5.68629 14.3137C4.77124 13.3987 4.77124 11.9151 5.68629 11",
  stroke: "currentColor"
})));
export default BellTiltedIcon;